(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProviderCategoryDialogController', ProviderCategoryDialogController);

    ProviderCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProviderCategory', 'ProviderCountry'];

    function ProviderCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProviderCategory, ProviderCountry) {
        var vm = this;

        vm.providerCategory = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.providercountries = ProviderCountry.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.providerCategory.id !== null) {
                ProviderCategory.update(vm.providerCategory, onSaveSuccess, onSaveError);
            } else {
                ProviderCategory.save(vm.providerCategory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:providerCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
